import type { Enemy } from '../Enemy';
import type { MovementBehavior } from './MovementBehavior';
import { getEnemyMovementTopY, getEnemyMovementBottomY, getFieldMidX } from '../../constants/field';
import { getEnemyMobileSpeedMultiplier } from '../../constants/scale';

type WolfPhase = 'approach' | 'charge';

export class WolfBehavior implements MovementBehavior {
  private phase: WolfPhase = 'approach';
  private chargeAngleRad = 0;
  private speedMultiplier = 1.35;
  private diagonalAngleDeg = 35;
  // Точка перехода фазы (середина сцены по X). Считается в init() от scene врага —
  // до init() у нас нет ссылки на enemy/scene.
  private phaseTransitionX = 0;

  init(enemy: Enemy, params?: Record<string, number>): void {
    if (params) {
      this.speedMultiplier = params.speedMultiplier ?? this.speedMultiplier;
      this.diagonalAngleDeg = params.diagonalAngleDeg ?? this.diagonalAngleDeg;
    }
    this.phaseTransitionX = getFieldMidX(enemy.scene);
  }

  update(enemy: Enemy, deltaMs: number, _target: { x: number; y: number }): void {
    const mobileMul = getEnemyMobileSpeedMultiplier();

    if (this.phase === 'approach') {
      const moveDistance = (enemy.config.speed * mobileMul * deltaMs) / 1000;
      enemy.x += moveDistance;

      if (enemy.x >= this.phaseTransitionX) {
        this.phase = 'charge';
        const sign = Math.random() < 0.5 ? -1 : 1;
        this.chargeAngleRad = (sign * this.diagonalAngleDeg * Math.PI) / 180;
      }
      return;
    }

    // Фаза charge: диагональ + ускорение (mobileMul применяется и тут — иначе charge
    // на мобильном становится почти 2× быстрее approach, что слишком резко).
    const effectiveSpeed = enemy.config.speed * this.speedMultiplier * mobileMul;
    const moveDistance = (effectiveSpeed * deltaMs) / 1000;
    enemy.x += Math.cos(this.chargeAngleRad) * moveDistance;
    enemy.y += Math.sin(this.chargeAngleRad) * moveDistance;

    const halfSize = enemy.displayWidth / 2;
    const minY = getEnemyMovementTopY(enemy.scene) + halfSize;
    const maxY = getEnemyMovementBottomY(enemy.scene) - halfSize;

    if (enemy.y < minY) {
      enemy.y = minY;
      this.chargeAngleRad = -this.chargeAngleRad;
    } else if (enemy.y > maxY) {
      enemy.y = maxY;
      this.chargeAngleRad = -this.chargeAngleRad;
    }
  }
}
